import { FETCH_ACCOUNTS_UNDER_NETWORK_SUCCESS } from './actionTypes';

const fetchAccountsUnderNetworkSuccess = (accountsUnderNetwork, accountsUnderNetworkTotal) => ({
    type: FETCH_ACCOUNTS_UNDER_NETWORK_SUCCESS,
    payload: { accountsUnderNetwork, accountsUnderNetworkTotal },
});

export default fetchAccountsUnderNetworkSuccess;
